import React from 'react'
import { useForm } from 'react-hook-form'
import PropTypes from 'prop-types'
import { makeStyles } from '@material-ui/core'
import SydModalActions from '../../../../../../commonDesign/SydModal/SydModalActions'
import SydButton from '../../../../../../commonDesign/Button'
import { useSetThingContent } from '../../../../../../../api/things'
import Editor from '../../../../../WYSIWYGEditor'

const useStyles = makeStyles((theme) => ({
  editorContainer: {
    '& .editor-input': {
      boxShadow: '0 4px 2px -4px inset',
      overflow: 'auto',
      maxHeight: '50vh'
    }
  },
  modalActions: {
    height: '100%',
    alignItems: 'flex-end'
  }
}))

export default function EditThingsForm ({
  defaultValues,
  onSubmit: _onSubmit,
  onCancel
}) {
  const classes = useStyles()

  const { handleSubmit, setValue } = useForm({
    defaultValues: {
      levelTypeId: defaultValues?.chartLevel?.levelTypeId,
      levelId: defaultValues?.chartLevel?.levelId,
      code: defaultValues?.code,
      content: defaultValues?.content || '',
      ordinal: defaultValues?.ordinal || 1
    }
  })

  const saveMutation = useSetThingContent()

  const onSubmit = async (data) => {
    const content = data?.content?.trim()?.length ? data.content : null
    const { thingId } = await saveMutation.mutateAsync({
      ...data,
      content
    })
    _onSubmit?.({
      ...data,
      thingId: !content ? null : thingId,
      data: { contentType: 'markdown' },
      description: content ?? defaultValues?.schema?.description,
      ...(!content && {
        levelId: null
      })
    })
  }

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Editor
        className={classes.editorContainer}
        defaultValue={defaultValues?.content || ''}
        isMarkdown
        onChange={(val) => setValue('content', val)}
      />
      <SydModalActions>
        <SydButton variant='secondary' size='md' onClick={onCancel}>Close</SydButton>
        <SydButton variant='primary' size='md' type='submit' processing={saveMutation.isLoading}>Save</SydButton>
      </SydModalActions>
    </form>
  )
}

EditThingsForm.propTypes = {
  defaultValues: PropTypes.shape({
    chartLevel: PropTypes.shape({
      levelId: PropTypes.number.isRequired,
      levelTypeId: PropTypes.number.isRequired
    }).isRequired,
    code: PropTypes.string.isRequired,
    content: PropTypes.string,
    ordinal: PropTypes.number,
    schema: PropTypes.shape({
      code: PropTypes.string,
      name: PropTypes.string,
      description: PropTypes.string
    })
  }),
  onSubmit: PropTypes.func,
  onCancel: PropTypes.func
}
